import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.03649 7.97577C8.7436 7.68288 8.26873 7.68288 7.97583 7.97577C7.68294 8.26867 7.68294 8.74354 7.97583 9.03643L10.9393 11.9999L7.97583 14.9633C7.68294 15.2562 7.68294 15.731 7.97583 16.0239C8.26873 16.3168 8.7436 16.3168 9.03649 16.0239L11.9999 13.0605L14.9633 16.0239C15.2562 16.3168 15.7311 16.3168 16.024 16.0239C16.3169 15.731 16.3169 15.2562 16.024 14.9633L13.0606 11.9999L16.024 9.03643C16.3169 8.74354 16.3169 8.26867 16.024 7.97577C15.7311 7.68288 15.2562 7.68288 14.9633 7.97577L11.9999 10.9392L9.03649 7.97577Z",
		fill: "var(--colors-grey-1)"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12Z",
		fill: "var(--colors-grey-1)"
	})]
});
export default SvgXCircle;
